import $ from 'domtastic'
import EventBus from '../../EventBus.vue'




/* MENU DROPDOWN
----------------------------------------------------------------------------------------------------*/

export default class DeleteResourceBtn {

    constructor($el) {
        this.$els = {
            body     : $(document.body),
            btn     : $($el),
        }

        this.clickHandler = () => { this.onClick() }

        this.bindEvents()
    }


    bindEvents() {
        this.$els.btn.on('click', this.clickHandler)
    }




    /* Handlers
    --------------------------------------------------------- */

    onClick() {
        EventBus.$emit('confirm-modal-open', {
            title: this.$els.btn.attr('data-title'),
            text: this.$els.btn.attr('data-text'),
            confirmBtnLabel: this.$els.btn.attr('data-confirm-btn-label'),
            cancelBtnLabel: this.$els.btn.attr('data-cancel-btn-label'),
            callback: () => {
                this.postForm(this.$els.btn.attr('data-url'))
            },
        })
    }




    /* Actions
    --------------------------------------------------------- */
    postForm(url) {
        const form = document.createElement('form')
        form.action = url
        form.method = 'POST'
        const typeInput = document.createElement('input')
        typeInput.type = 'hidden'
        typeInput.name = '_method'
        typeInput.value = 'DELETE'
        const csrfToken = document.createElement('input')
        csrfToken.type = 'hidden'
        csrfToken.name = '_token'
        csrfToken.value = document.querySelector('meta[name="csrf-token"]').content
        form.append(csrfToken)
        form.append(typeInput)
        this.$els.body.append(form)
        form.submit()
    }



    /* Values
    --------------------------------------------------------- */

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



